import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={14} height={13} fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.58 8.941a.391.391 0 01-.32.614H.78v3.055a.39.39 0 01-.78 0V.39a.39.39 0 01.78 0v.585h12.48a.389.389 0 01.318.614l-2.572 3.676 2.574 3.676z" /></svg>;
}
export default SvgComponent;